export default __webpack_public_path__ + "img/BB_RT_NOMA_BF.f1c187e7307dddcab69e2fe75be8cefc.jpg";